// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-item[data-v-264bddce] {\n  display: flex;\n  margin-bottom: 0.8rem;\n}\n.list-item[data-v-264bddce]:last-child {\n  margin-bottom: 0;\n}\n.list-item--icon[data-v-264bddce] {\n  width: 1.6rem;\n  margin: auto 0;\n}\n.list-item--icon svg[data-v-264bddce] {\n  width: 100%;\n  display: block;\n}\n.list-item--text[data-v-264bddce] {\n  font-size: 1.2rem;\n  margin-left: 0.8rem;\n  color: #323653;\n  width: calc(100% - 1.6rem);\n}", ""]);
// Exports
module.exports = exports;
